export default {
  /**
   * 复杂密码校验规则
   * @param banStrs 密码中不可出现的字符集合
   * @returns {Function}
   */
  complexPwd (banStrs) {
    return (rule, value, callback) => {
      if (value !== undefined && value !== null && value !== '') {
        const digitLint = RegExp('^.{7,25}$')
        const hasNum = RegExp('^.*[0-9]+.*$')
        const hasUpper = RegExp('^.*[A-Z]+.*$')
        const hasLower = RegExp('^.*[a-z]+.*$')
        const hasSpec = RegExp('^.*[!@$%^\\-_=+\\[\\]\\{\\}:,/?]+.*$')

        if (!digitLint.test(value))callback(new Error('密码的长度必须控制在8至26'))

        /**
         * 包含至少三种字符类型
         */
        let charsetMatch = 0
        if (hasNum.test(value)) charsetMatch++
        if (hasUpper.test(value)) charsetMatch++
        if (hasLower.test(value)) charsetMatch++
        if (hasSpec.test(value)) charsetMatch++
        if (charsetMatch < 3) callback(new Error('由数字、字母、特殊字符组成，且至少包含三种'))

        /**
         * 不可包含指定字符，正序逆序
         */
        if (banStrs) {
          if (typeof (banStrs) === 'string') banStrs = [banStrs]
          banStrs.forEach((str) => {
            if (!RegExp(`^((?!${str}).)*$`).test(value) || !RegExp(`^((?!${str.split('').reverse().join('')}).)*$`).test(value)) {
              callback(new Error(`密码不可包含${str}正序或逆序`))
            }
            let keywords = ''
            for (let i = 0; i < str.length - 1; i++) {
              keywords += `.*${str[i]}${str[i + 1]}`
              if (i < str.length - 2)keywords += '|'
              else break
            }
            if (!RegExp(`(?!${keywords})(^.*$)`).test(value)) callback(new Error(`密码不可包含${str}中的两个连续字符`))
          })
        }
      }
      callback()
    }
  },
  pwdStrength (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('(?!^(\\d+|[a-zA-Z]+|[`~!@#$%^&*()/?.>,<\'";:|\\\\{}\\[\\]_+=-]+)$)^[\\w`~!@#$%^&*()/?.>,<\'";:|\\\\{}\\[\\]_+=-]+$').test(value)) {
        callback(new Error('由数字、字母、特殊字符组成，且至少包含两种'))
      }
    }
    callback()
  }
}
